
import { Vue, Component, Prop } from "vue-property-decorator";
import logPanel from "./log-panel.vue";
import XLSX, { WorkBook } from "xlsx";
import { ExcelHelper } from "@newview/tools";
@Component({
  name: "ExcelImport",
  components: {
    logPanel
  }
})
export default class ExcelImport extends Vue {
  @Prop({ default: false }) isSheetGroup!: Boolean; //是否按sheet页分组返回导入数据（一般不传） 传入true时则不提供选择sheet页下拉列表，会将所有sheet页数据全部返回
  @Prop({ default: false }) isExportTemp!: Boolean; //是否有导出操作   默认没有
  @Prop({ default: false }) isNoImportBtn!: Boolean; //不显示导入组件情况下使用
  
  /*   
    关于模板导出配置 -- 开始
    配置项详解： 
      {
        name 模板导出文件名[string]    eg: "人员登记表"
        header 表头[array]            eg: ["姓名","年龄","家庭住址"]
        example 示例数据[array]       eg:["小明","26","陕西省西安市XXX"]
      }
  */
  @Prop({ default: {name:"",header:null,example:null} }) tempConfig!: any;
  // 关于模板导出配置 -- 结束
  
  excelHelper: ExcelHelper = new ExcelHelper();
  selectedSheetIsLoading=false
  selectedSheet = "";
  sheetNames: string[] = [];
  wb: WorkBook | undefined;
  make_cols = refstr =>
    Array(XLSX.utils.decode_range(refstr).e.c + 1)
      .fill(0)
      .map((x, i) => ({ name: XLSX.utils.encode_col(i), key: i }));
  SheetJSFT = [
    "xlsx",
    "xlsb",
    "xlsm",
    "xls",
    "xml",
    "csv",
    "txt",
    "ods",
    "fods",
    "uos",
    "sylk",
    "dif",
    "dbf",
    "prn",
    "qpw", 
    "wb*",
    "wq*",
    "html",
    "htm"
  ]
    .map(function(x) {
      return "." + x;
    })
    .join(",");
  data: any[] = ["SheetJS".split(""), "1234567".split("")];
  cols = [
    { name: "A", key: 0 },
    { name: "B", key: 1 },
    { name: "C", key: 2 },
    { name: "D", key: 3 },
    { name: "E", key: 4 },
    { name: "F", key: 5 },
    { name: "G", key: 6 }
  ];
  Id(id) {
    return document.getElementById(id) as any;
  }
  ref(refName) {
    return this.$refs[refName] as any;
  }
  error(content: string) {
    this.ref("log").error(content);
  }
  warning(content: string) {
    this.ref("log").warning(content);
  }
  message(content: string) {
    this.ref("log").message(content);
  }

  _suppress(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }
  _drop(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    const files = evt.dataTransfer.files;
    if (files && files[0]) this.readFile(files[0]);
  }

  _export(evt) {
    /* convert state to workbook */
    const ws = XLSX.utils.aoa_to_sheet(this.data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate file and send to client */
    XLSX.writeFile(wb, "sheetjs.xlsx");
  }

  readFile(file) {    
    this.selectedSheetIsLoading=true
    this.$forceUpdate()
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    reader.onload = e => {
      /* Parse data */
      const bstr = e.target!.result;
      this.wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      console.log(this.wb.SheetNames)
      this.sheetNames = this.wb.SheetNames;
      const wsname = this.wb.SheetNames[0];
      this.selectedSheet = wsname;
      this.$emit("callbackSheet", this.selectedSheet);
      // console.log(this.selectedSheet);
      this.message(`${file.name} 读取完成`);
      this.selectedSheetIsLoading=false
      // 不显示导入按钮情况下，读取完成立即导出
      if(this.isNoImportBtn){
        this.handleImportExcel()
      }
    };
    reader.readAsBinaryString(file);
  }

  readSheetName(sheetName: string) {
    const ws = this.wb!.Sheets[sheetName];
    /* Convert array of arrays */
    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
    /* Update state */
    this.data = data;
    this.cols = this.make_cols(ws["!ref"]);
  }

  handleFileChange(evt) {
    const files = evt.target.files;
    this.$emit("startchangeFile",files)
    if (files && files[0]) {
      this.readFile(files[0]);
    }
  }

  handleSelectChange() {
    this.message(`切换到${this.selectedSheet}页`);
    this.$emit("callbackSheet", this.selectedSheet);
  }

  handleImportExcel() {
    const jsonData: any[] = [];
    let Data2:any = []
    let wsmap = new Map<string, any>();
    if (this.isSheetGroup) {
      for(let value of this.sheetNames) {
        console.log(value);
        const ws = this.wb!.Sheets[value];
        let tpkey = Object.keys(ws);
        let tpvalue = Object.values(ws);
        tpkey.forEach((value, i) => {
          if (value[value.length - 1] == "1") {
            let dt = tpvalue[i].hasOwnProperty("c")
              ? tpvalue[i].c.hasOwnProperty("0")
                ? tpvalue[i].c[0].t
                : null
              : null;
            wsmap.set(i - 1 + "", dt);
          }
        });
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        if (data.length < 1) {
          this.error("Excel表格格式不正确");
          return;
        }

        const keys = data[0] as any[];
        for (let i = 1; i < data.length; i++) {
          const rows = data[i] as any[];
          const jsonContent: any = {};
          for (let j = 0; j < rows.length; j++) {
            let rem = wsmap.get(j + "");
            jsonContent[keys[j]] = { value: rows[j], remark: rem };
          }
          jsonContent.TbName= value;
          jsonContent.TbRow= i;
          jsonData.push(jsonContent);
        }
      }
    } 
    else {
      const ws = this.wb!.Sheets[this.selectedSheet];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      Data2 = data
      if (data.length < 1) {
        this.error("Excel表格格式不正确");
        return;
      }

      const keys = data[0] as any[];
      for (let i = 1; i < data.length; i++) {
        const rows = data[i] as any[];
        const jsonContent: any = {};
        for (let j = 0; j < rows.length; j++) {
          jsonContent[keys[j]] = rows[j];
        }
        jsonData.push(jsonContent);
      }
    }

    //this.message(JSON.stringify(jsonData));
    this.$emit("callbackData", jsonData,Data2);
  }

  mounted() {
  }
  selectFile(){
    this.Id('file').click()
  }

  downloadTemp(){
    let downData:any = []
    if(this.tempConfig.header && this.tempConfig.header.length>0){
      downData.push(this.tempConfig.header)
      if(this.tempConfig.example && this.tempConfig.example.length>0){
        downData.push(this.tempConfig.example)
      }
    }
    this.excelHelper.downloadExcel(downData,(this.tempConfig.name?this.tempConfig.name:"模板")+".xlsx");
  }
}
